import { API_URL } from "../config";
import { setSession } from "../store/slices/session-slice";

export const fetchSession = () => async (dispatch, getState) => {
  const { session } = getState().session;

  if (session?.fechaExpira) {
    const fechaExpira = new Date(session.fechaExpira);
    if (fechaExpira > new Date()) return;
  }

  const url = `${API_URL}/api/v2/Session`;

  try {
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) return;

    const data = await response.json();
    dispatch(setSession(data));
    return data;
  } catch {
    // La sesion puede fallar si la base local no esta disponible; no bloquea la carga inicial.
    return null;
  }
};
